if (typeof document !== 'undefined' && !document.head.querySelector("style[data-wp-hash='1d12353983']")) {
	const style = document.createElement("style");
	style.setAttribute("data-wp-hash", "1d12353983");
	style.appendChild(document.createTextNode(".boot-dropdown-item__children{display:flex;flex-direction:column;margin-block-end:2px;margin-block-start:-2px;margin-inline-start:30px;overflow:hidden;padding:2px}.boot-dropdown-item__chevron.is-up{transform:rotate(180deg)}"));
	document.head.appendChild(style);
}
